<template>
  <section data-section-type="icons" data-section-id="template--14965984165948__165110675090fb7ecc" class="relative overflow-hidden px-5 pt-12 font-open-sans" style="background-color: #ffffff">
    <div class="max-w-7xl w-full mx-auto flex flex-wrap justify-between overflow-hidden">

      <!-- Iterate over items -->
      <div v-for="(item, index) in items" :key="index" class="my-3 px-3 w-1/2 overflow-hidden sm:w-1/3 md:w-1/3 lg:w-1/6 xl:w-1/6">
        <div class="flex flex-col items-center text-center lg:p-2 space-y-2.5">
          <div class="wkit_box h-14 w-14">
            <nuxt-img class="w-full h-full"
                      :src="item.imgSrc"
                      :width="64"
                      :height="64"
                      loading="lazy"
                      format="webp"
                      :alt="item.imgAlt"/>
          </div>
          <p class="textp" v-html="item.text"></p>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>


const props = defineProps({
  items: {
    type: Array,
    default: () => ([
      {
        imgSrc: '/assets/images/benefits-img-1.svg',
        imgAlt: 'benefits-1',
        text: 'Non-GMO, single-origin, USDA-certified organic coffee'
      },
      {
        imgSrc: '/assets/images/benefits-img-2.svg',
        imgAlt: 'benefits-2',
        text: 'pH test proven to be up to 27.7% less acidic than common store-bought coffees'
      },
      {
        imgSrc: '/assets/images/benefits-img-3.svg',
        imgAlt: 'benefits-3',
        text: 'Shade-grown & sun-dried high in the mountains of Central America'
      },
      {
        imgSrc: '/assets/images/benefits-img-4.svg',
        imgAlt: 'benefits-4',
        text: 'Fairly traded, tested for pesticide, & chemical, pure antioxidant-rich coffee'
      },
      {
        imgSrc: '/assets/images/benefits-img-5.svg',
        imgAlt: 'benefits-5',
        text: '2-year shelf life'
      },
      {
        imgSrc: '/assets/images/benefits-img-6.svg',
        imgAlt: 'benefits-6',
        text: 'No lines, no rationing - delivered directly to your door'
      }
    ])
  }
});

defineBuilderComponent({
    friendlyName: "Benefits",
    canHaveChildren: true,
    inputs: [
        {
            name: "items",
            type: "list",
            defaultValue: [
                {
                    imgSrc: "/assets/images/benefits-img-1.svg",
                    imgAlt: "benefits-1",
                    text: "Non-GMO, single-origin, USDA-certified organic coffee"
                },
                {
                    imgSrc: "/assets/images/benefits-img-2.svg",
                    imgAlt: "benefits-2",
                    text: "pH test proven to be up to 27.7% less acidic than common store-bought coffees"
                },
                {
                    imgSrc: "/assets/images/benefits-img-3.svg",
                    imgAlt: "benefits-3",
                    text: "Shade-grown & sun-dried high in the mountains of Central America"
                },
                {
                    imgSrc: "/assets/images/benefits-img-4.svg",
                    imgAlt: "benefits-4",
                    text: "Fairly traded, tested for pesticide, & chemical, pure antioxidant-rich coffee"
                },
                {
                    imgSrc: "/assets/images/benefits-img-5.svg",
                    imgAlt: "benefits-5",
                    text: "2-year shelf life"
                },
                {
                    imgSrc: "/assets/images/benefits-img-6.svg",
                    imgAlt: "benefits-6",
                    text: "No lines, no rationing - delivered directly to your door"
                }
            ],
            subFields: [
                {
                    name: "imgSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    required: true,
                    defaultValue: ""
                },
                {
                    name: "imgAlt",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "text",
                    type: "richText",
                    defaultValue: ""
                }
            ]
        }
    ]
});
</script>